import { SequenceManagerAction } from "./SequenceManagerAction";

const NumberOptionAction = {
  MAKE_SELECTION : "MAKE_SELECTION",
}

const makeSelection = (selection: any, selectionText: any, offerContainerId: any) => {
  return function (dispatch: any) {
    dispatch({ type: NumberOptionAction.MAKE_SELECTION, payload: { selection: selection, selectionText: selectionText, offerContainerId: offerContainerId } });
    dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['NumberOption'] });
  };
};

export { NumberOptionAction, makeSelection };
